export const translationGlossaryDe = {
  title: 'Sprachen & Übersetzungen',
  subtitle: 'Unternehmensbegriffe für konsistente, kontrollierte Übersetzungen pflegen.',
  privacyTitle: 'Datenschutzgrenze',
  privacyHint:
    'Verwenden Sie nur Fachbegriffe, Marken, Einheiten und interne Bezeichnungen – keine Kunden-, Artikel- oder Belegdaten.',
  search: 'Begriff suchen',
  sourceLanguage: 'Ausgangssprache',
  all: 'Alle',
  showArchived: 'Archivierte anzeigen',
  create: 'Begriff anlegen',
  createTitle: 'Glossarbegriff anlegen',
  editTitle: 'Glossarbegriff bearbeiten',
  formHint: 'Konflikte werden je Mandant und Ausgangssprache geprüft.',
  sourceTerm: 'Ausgangsbegriff',
  protected: 'Geschützt',
  caseSensitive: 'Groß-/Kleinschreibung beachten',
  protectedHint: 'Geschützte Begriffe bleiben in jeder Zielsprache bytegenau unverändert.',
  targetTerms: 'Übersetzungen je Zielsprache',
  saved: 'Glossareintrag gespeichert.',
  empty: 'Noch keine passenden Glossarbegriffe.',
  translations: 'Übersetzungen',
  properties: 'Eigenschaften',
  actions: 'Aktionen',
  archived: 'Archiviert',
  archive: 'Archivieren',
  archivedMessage: 'Glossareintrag archiviert.',
} as const;

export const translationGlossaryEn = {
  title: 'Languages & translations',
  subtitle: 'Maintain company terminology for consistent, controlled translations.',
  privacyTitle: 'Privacy boundary',
  privacyHint:
    'Use specialist terms, brands, units and internal names only—never customer, product or document data.',
  search: 'Search term',
  sourceLanguage: 'Source language',
  all: 'All',
  showArchived: 'Show archived',
  create: 'Add term',
  createTitle: 'Create glossary term',
  editTitle: 'Edit glossary term',
  formHint: 'Conflicts are checked per tenant and source language.',
  sourceTerm: 'Source term',
  protected: 'Protected',
  caseSensitive: 'Case-sensitive',
  protectedHint: 'Protected terms remain byte-for-byte unchanged in every target language.',
  targetTerms: 'Translations by target language',
  saved: 'Glossary entry saved.',
  empty: 'No matching glossary terms yet.',
  translations: 'Translations',
  properties: 'Properties',
  actions: 'Actions',
  archived: 'Archived',
  archive: 'Archive',
  archivedMessage: 'Glossary entry archived.',
} as const;

export const translationGlossaryFr = {
  title: 'Langues et traductions',
  subtitle: 'Gérez la terminologie de l’entreprise pour des traductions cohérentes et contrôlées.',
  privacyTitle: 'Limite de confidentialité',
  privacyHint:
    'Utilisez uniquement des termes métier, marques, unités et noms internes, jamais de données client, article ou document.',
  search: 'Rechercher un terme',
  sourceLanguage: 'Langue source',
  all: 'Toutes',
  showArchived: 'Afficher les archives',
  create: 'Ajouter un terme',
  createTitle: 'Créer un terme',
  editTitle: 'Modifier le terme',
  formHint: 'Les conflits sont contrôlés par locataire et langue source.',
  sourceTerm: 'Terme source',
  protected: 'Protégé',
  caseSensitive: 'Respecter la casse',
  protectedHint: 'Les termes protégés restent strictement inchangés dans chaque langue cible.',
  targetTerms: 'Traductions par langue cible',
  saved: 'Entrée de glossaire enregistrée.',
  empty: 'Aucun terme correspondant.',
  translations: 'Traductions',
  properties: 'Propriétés',
  actions: 'Actions',
  archived: 'Archivé',
  archive: 'Archiver',
  archivedMessage: 'Entrée de glossaire archivée.',
} as const;

export const translationGlossaryEs = {
  title: 'Idiomas y traducciones',
  subtitle: 'Mantenga la terminología de la empresa para traducciones coherentes y controladas.',
  privacyTitle: 'Límite de privacidad',
  privacyHint:
    'Use solo términos especializados, marcas, unidades y nombres internos; nunca datos de clientes, artículos o documentos.',
  search: 'Buscar término',
  sourceLanguage: 'Idioma de origen',
  all: 'Todos',
  showArchived: 'Mostrar archivados',
  create: 'Añadir término',
  createTitle: 'Crear término',
  editTitle: 'Editar término',
  formHint: 'Los conflictos se comprueban por inquilino e idioma de origen.',
  sourceTerm: 'Término de origen',
  protected: 'Protegido',
  caseSensitive: 'Distinguir mayúsculas',
  protectedHint:
    'Los términos protegidos permanecen idénticos byte a byte en cada idioma de destino.',
  targetTerms: 'Traducciones por idioma de destino',
  saved: 'Entrada de glosario guardada.',
  empty: 'Aún no hay términos coincidentes.',
  translations: 'Traducciones',
  properties: 'Propiedades',
  actions: 'Acciones',
  archived: 'Archivado',
  archive: 'Archivar',
  archivedMessage: 'Entrada de glosario archivada.',
} as const;

export const translationGlossaryRu = {
  title: 'Языки и переводы',
  subtitle: 'Ведите терминологию компании для единообразных контролируемых переводов.',
  privacyTitle: 'Граница конфиденциальности',
  privacyHint:
    'Используйте только термины, бренды, единицы и внутренние названия, но не данные клиентов, товаров или документов.',
  search: 'Поиск термина',
  sourceLanguage: 'Исходный язык',
  all: 'Все',
  showArchived: 'Показать архив',
  create: 'Добавить термин',
  createTitle: 'Создать термин',
  editTitle: 'Изменить термин',
  formHint: 'Конфликты проверяются по арендатору и исходному языку.',
  sourceTerm: 'Исходный термин',
  protected: 'Защищён',
  caseSensitive: 'Учитывать регистр',
  protectedHint: 'Защищённые термины сохраняются без единого изменения во всех языках.',
  targetTerms: 'Переводы по целевым языкам',
  saved: 'Запись глоссария сохранена.',
  empty: 'Подходящих терминов пока нет.',
  translations: 'Переводы',
  properties: 'Свойства',
  actions: 'Действия',
  archived: 'В архиве',
  archive: 'Архивировать',
  archivedMessage: 'Запись глоссария архивирована.',
} as const;

export const translationGlossaryTr = {
  title: 'Diller ve çeviriler',
  subtitle: 'Tutarlı ve kontrollü çeviriler için şirket terimlerini yönetin.',
  privacyTitle: 'Gizlilik sınırı',
  privacyHint:
    'Yalnızca uzmanlık terimleri, markalar, birimler ve iç adlar kullanın; müşteri, ürün veya belge verisi kullanmayın.',
  search: 'Terim ara',
  sourceLanguage: 'Kaynak dil',
  all: 'Tümü',
  showArchived: 'Arşivlenenleri göster',
  create: 'Terim ekle',
  createTitle: 'Sözlük terimi oluştur',
  editTitle: 'Sözlük terimini düzenle',
  formHint: 'Çakışmalar kiracı ve kaynak dil bazında denetlenir.',
  sourceTerm: 'Kaynak terim',
  protected: 'Korumalı',
  caseSensitive: 'Büyük/küçük harfe duyarlı',
  protectedHint: 'Korumalı terimler her hedef dilde bayt bayt değişmeden kalır.',
  targetTerms: 'Hedef dile göre çeviriler',
  saved: 'Sözlük kaydı kaydedildi.',
  empty: 'Henüz eşleşen sözlük terimi yok.',
  translations: 'Çeviriler',
  properties: 'Özellikler',
  actions: 'İşlemler',
  archived: 'Arşivlendi',
  archive: 'Arşivle',
  archivedMessage: 'Sözlük kaydı arşivlendi.',
} as const;
